import React from 'react';
import { ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { ProductArtwork } from './ProductArtwork';
import { PRODUCT_NAME } from './constants';
export function FinalCTA() {
  return <section className="border-t-8 border-sport bg-navy px-4 py-7 text-white sm:py-9" data-id="element-47">
      <div className="mx-auto max-w-3xl text-center" data-id="element-48">
        <p className="text-xs font-display font-bold uppercase tracking-widest text-sport" data-id="element-49">
          ONE LAST CHANCE
        </p>
        <div className="mx-auto mt-2 max-w-2xl space-y-2 text-sm leading-relaxed text-white/90 sm:text-base" data-id="element-50">
          <p data-id="element-51">
            Your athletes deserve more than training sessions created at the
            last minute because you simply ran out of planning time.
          </p>
          <p data-id="element-52">
            Stop spending hours building strength programs, creating workouts,
            organizing periodization, and planning every training session from
            scratch.
          </p>
          <p data-id="element-53">
            Stop wasting valuable time jumping between books, certifications,
            spreadsheets, websites, videos, and scattered coaching files.
          </p>
          <p data-id="element-54">
            Deliver every session with structure, confidence, and a professional
            coaching system built to help your athletes become stronger, faster,
            and perform at their highest level.
          </p>
          <p data-id="element-55">
            Give yourself the complete Strength &amp; Conditioning coaching
            system you wish you had from your very first training session.
          </p>
        </div>

        <ProductArtwork className="mx-auto my-4 max-w-[220px] drop-shadow-2xl" data-id="element-56" />

        <div className="rounded-xl border border-white/25 bg-white/10 p-3" data-id="element-57">
          <p className="text-sm font-display font-bold uppercase" data-id="element-58">
            💪 {PRODUCT_NAME} — Complete 6-in-1 Planning System + 5 Premium
            Bonuses
          </p>
          <p className="mt-1 text-sm" data-id="element-59">
            <span className="line-through text-white/65" data-id="element-60">
              Regular Price: $97
            </span>{' '}
            <span className="text-sport" data-id="element-61">| Today Only: $27 USD</span>
          </p>
        </div>

        <div className="mx-auto mt-4 max-w-md" data-id="element-62">
          <CTAButton className="!bg-sport !shadow-sport/30 hover:!bg-[#e37835]" data-id="element-63">
            🚀 YES! I WANT MY STRENGTH READY™ SYSTEM
          </CTAButton>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-xs font-bold text-white/90" data-id="element-64">
          <span className="inline-flex items-center gap-1" data-id="element-65">
            <ZapIcon className="h-4 w-4 text-sport" data-id="element-66" />
            Immediate Access • Delivered Instantly by Email
          </span>
          <span className="inline-flex items-center gap-1" data-id="element-67">
            <StarIcon className="h-4 w-4 fill-sport text-sport" data-id="element-68" />
            4.9/5 — Verified Coach Reviews
          </span>
          <span className="inline-flex items-center gap-1" data-id="element-69">
            <ShieldCheckIcon className="h-4 w-4 text-sport" data-id="element-70" />
            7-Day Money-Back Guarantee — Zero Risk
          </span>
        </div>
      </div>
    </section>;
}